import { Box } from '@tonic-one/react';
import TargetList from '@Components/TargetList';
import { PocBasicTreeNode } from './type';
import { useTranslation } from 'react-i18next';

export const PocRightTransferBox = ({
  onDelete,
  data,
}: {
  onDelete: (k: string) => void;
  data: PocBasicTreeNode[];
}) => {
  const { t } = useTranslation('policy');
  return (
    <Box flex="1">
      <TargetList
        title={t('policy:policy.label.selectedTargets')}
        disabled={false}
        list={data}
        onDelete={onDelete}
        limit={100}
        size={9}
      />
    </Box>
  );
};
